import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class PortosService extends Service{

  protected url: string = this.dominio+"/adm/portos/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  getById(id){
    let headers = this.getHeaderLogado();

    return this.http.get(this.url + id+'/?relations=["pais"]', {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/portos/portos.service.ts